import { CustomCheckBox } from 'components/input';
import React, { useEffect, useState } from 'react';
import { IStyle } from 'Styles/styleModel';
import { useOnSelectAllCrystals } from './hooks';
import { CrystalMenuButtons } from './index';
import { useSelectedTripsCrystals } from 'redux/hooks/synchrotron';
const CrystalsHeader = ({ className = '' }: { className?: string }) => {
  const [allCrystalSelect, setAllCrystalsSelect] = useState(false);
  const selectedTripCrystals = useSelectedTripsCrystals();
  const selectAllCrystals = useOnSelectAllCrystals(
    allCrystalSelect,
    setAllCrystalsSelect,
  );

  useEffect(() => {
    if (
      !selectedTripCrystals?.length ||
      selectedTripCrystals?.some((x) => !x.isChecked)
    ) {
      setAllCrystalsSelect(false);
    } else {
      setAllCrystalsSelect(true);
    }
  }, [selectedTripCrystals]);

  return (
    <div id="exp-crsytalheader-container" style={styles.cartHeader} className={className}>
      <CustomCheckBox
        id="exp-crsytalheader-checkbox"
        label="Select All"
        labelStyle={{ fontSize: 15, marginLeft: '0.5rem' }}
        checked={allCrystalSelect}
        onChange={selectAllCrystals}
        disabled={!selectedTripCrystals?.length}
      />
      <div id="exp-crsytalheader-menu" style={styles.buttons}>
        <CrystalMenuButtons />
      </div>
    </div>
  );
};
const styles: IStyle = {
  cartHeader: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
  },
  buttons: {
    display: 'flex',
    width: '67%',
    justifyContent: 'end',
  },
};
export default CrystalsHeader;
